import request from '@/utils/request'
import qs from 'qs'
export function getListRevenueBookingReport(query) {
  return request({
    url: '/report-service/v1/revenue-report/booking',
    method: 'get',
    params: query,
    paramsSerializer: query => {
      return qs.stringify(query, {
        arrayFormat: 'repeat',
        encode: false
      })
    }
  })
}
export function getListRevenueBookingReportExcel(query) {
  return request({
    url: '/report-service/v1/revenue-report/booking/excel',
    method: 'get',
    params: query,
    paramsSerializer: query => {
      return qs.stringify(query, {
        arrayFormat: 'repeat',
        encode: false
      })
    },
    responseType: 'blob'
  })
}
